import { render } from "./informationMatch.vue?vue&type=template&id=6d70d142&scoped=true"
import script from "./informationMatch.vue?vue&type=script&lang=js"
export * from "./informationMatch.vue?vue&type=script&lang=js"

import "./informationMatch.vue?vue&type=style&index=0&id=6d70d142&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d70d142"]])

export default __exports__